import { Box, List, Skeleton } from '@mui/material';

export const ListSkeletonLoader = ({ items = 5 }: { items?: number }) => {
  return (
    <List dense disablePadding>
      <Box p={2}>
        {Array.from({ length: items }).map((_, index) => (
          <Skeleton key={index} />
        ))}
      </Box>
    </List>
  );
};
